<h1>{{ 'turbo.core.DatePickerDialog.txtHeadline' | translate : 'Select date' }}</h1>
<div>
    <div>
        <mat-form-field style="width: 100%; min-width: 300px;" appearence="outline">
            <input #txtDate matInput [matDatepicker]="dp" placeholder="{{'Turbo.Core.DatePickerDialog.lblDate' |translate : 'Select date' }}" [(ngModel)]="selectedDate" [min]="minDate" [max]="maxDate">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
        </mat-form-field>
    </div>
    <div style="text-align: center;">
        <button mat-raised-button style="margin: 2px;" color="primary" [mat-dialog-close]="selectedDate" [disabled]="!selectedDate">{{ 'turbo.core.DatePickerDialog.cmdSend' | translate : 'Select' }}</button>
        <button mat-raised-button style="margin: 2px;" mat-dialog-close>{{ 'turbo.core.DatePickerDialog.cmdCancel' | translate : 'Cancel' }}</button>
    </div>
</div>
